














import { KisweSelectOption } from '@/modules/kisweui/types'
import { KisweSelect } from '@/modules/kisweui/components'
import { elementUiSize } from '@/modules/kisweui/validators/propsValidators'
import { computed, defineComponent } from '@vue/composition-api'
import { useTranscodingRegions } from '@/modules/transcodingregions/compositions'
import { pickBy, sortBy } from 'lodash'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { can } from '@/ability'

export default defineComponent({
  name: 'SelectTranscodingRegion',
  components: {
    KisweSelect
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: null,
      validator: elementUiSize
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    }
  },
  setup (props) {
    const canDoOps = computed(() => {
      return can.value(AbilityAction.Do, AbilitySubject.Ops)
    })
    const { transcodingregions, visibleRegions } = useTranscodingRegions()
    const regionOptions = computed(() => {
      const options: KisweSelectOption[] = []
      const regions = canDoOps.value ? transcodingregions.value : visibleRegions.value
      for (const key in regions) {
        options.push({ label: regions[key].name, value: key })
      }
      if (options.find((option) => option.value === props.value) === undefined) {
        const objects = pickBy(transcodingregions.value, (_, id) => id === props.value)
        Object.keys(objects).forEach((key) => options.push({ label: objects[key].name, value: key }))
      }
      return sortBy(options, (option) => option.label.toLowerCase())
    })
    return {
      regionOptions
    }
  },
  computed: {
    selectedRegion: {
      get (): string {
        return this.value
      },
      set (newVal: string) {
        this.$emit('input', newVal)
      }
    }
  }
})
